import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../store/AuthContext";
import { Link } from "react-router-dom";

import { Col, Flex, Form, Input, Checkbox, Button, Row } from "antd";
import { PageHeader } from "../../components/PageHeader/PageHeader";
import { Notification } from "../../components/Notification/Notification";

import css from "../Dashboard/Dashboard.module.css";

export const Login = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  const { login, user, error, loading } = useAuth(); 
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMode, setNotificationMode] = useState('error');
  const [notificationMessage, setNotificationMessage] = useState("");
  
  useEffect(() => {
  	if (user) {
		navigate("/");
  	}
  }, [user]);

	useEffect(() => {
    if (error) {
      setShowNotification(true);
	  setNotificationMode('error');
      setNotificationMessage(error);
	  return;
    }

    if (location.search.includes('?from')) {
		const from = location.search.split('=')[1];
		setShowNotification(true);
		switch (from) {
			case 'signup':
				setNotificationMode('success');
				setNotificationMessage("Your account was activated, please log in with your new credentials");
			break;			
			case 'password_recovery':
			  setNotificationMode('success');
			  setNotificationMessage("Your password was changed successfully, please log in");
		  	break;
			case 'refresh_error':
			  setNotificationMode('error');
			  setNotificationMessage("Session status expired, please log in again");
			break;
			case 'token_expired':
			  setNotificationMode('error');
			  setNotificationMessage("Invitation token is invalid or expired, please contact your group administrator");
			break;
			
			

			
		}
    }
  }, [error, location.search]);
  
  const onFinish = (values) => {
	// token ttl, 5 min / 1 month  
	const ttl = values.remember ? 2628288 : 108000;  
  	login(values.email, values.password, ttl);	
  };
  
  const onFinishFailed = (errorInfo) => {
  	//console.log('Failed:', errorInfo);
  };
  
  return (
	<Flex className={css.root} vertical align="center">
		<Notification
			mode={notificationMode}
			message={notificationMode == 'error' ? "Error" : "Notification"}
			description={notificationMessage}
			showNotification={showNotification}
			cancel={() => setShowNotification(false)}
		/>

		<Form
			name="basic"
			labelCol={{
				span: 8,
			}}
			wrapperCol={{
				span: 16,
			}}
			style={{
				maxWidth: 600,
				width: '100%'
			}}
			initialValues={{
				remember: true,
			}}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			autoComplete="off"
			>

			<Form.Item
				label="Email"
				name="email"
				rules={[
					{
						required: true,
						message: 'Email is required',
					},
				]}
			>
				<Input />
			</Form.Item>
		
			<Form.Item
				label="Password"
				name="password"
				rules={[
					{
						required: true,
						message: 'Password is required',
					},
				]}
			>
				<Input.Password />
			</Form.Item>
			<Form.Item
				name="remember"
				valuePropName="checked"
				wrapperCol={{
					offset: 8,
					span: 16,
				}}
			>
			<Checkbox>Remember me</Checkbox>
			</Form.Item>
			<Form.Item
				wrapperCol={{
					offset: 8,
					span: 16,
				}}
			>
				<Button type="primary" htmlType="submit">
					Submit
				</Button>
			</Form.Item>
			<Form.Item
					name="forgotPassword"
					wrapperCol={{
						offset: 8,
						span: 16,
					}}
				>
				<Link to='/forgot_password'>Forgot password?</Link>
			</Form.Item>
		</Form>
	</Flex>
  );
};
